const DELIMITER_ROW_PATTERN = /^\|?[\s:|-]*-{3,}[\s:|-]*\|?$/;

export const hasMarkdownTable = (text: string): boolean => {
  const lines = text.split("\n");

  return lines.some((line, index) => {
    const next = lines[index + 1];
    return (
      line.includes("|") &&
      next !== undefined &&
      DELIMITER_ROW_PATTERN.test(next.trim())
    );
  });
};
